import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, FileText, ChevronRight, MapPin } from "lucide-react";
import { AppShell } from "@/components/AppShell";
import { DemoBadge } from "@/components/Badges";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function Trips() {
  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/trips");
        setTrips(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <AppShell active="trips">
      <h1 className="font-head text-3xl font-extrabold text-[#F8FAFC]">My Trips</h1>
      <p className="text-[#A1A1AA] mt-1">Your destinations and Travel Confidence Reports.</p>

      <Button
        data-testid="trips-new-btn"
        onClick={() => navigate("/trips/new")}
        className="mt-5 w-full min-h-[56px] rounded-xl bg-[#EF9F27] hover:bg-[#EF9F27] text-white text-lg font-semibold"
      >
        <Plus size={22} className="mr-2" /> Plan a new trip
      </Button>

      <div className="mt-6">
        {loading ? (
          <div className="space-y-3">
            {[0, 1].map((i) => (
              <div key={i} className="h-24 bg-[#1A1A1A] rounded-2xl border border-[#333333] animate-pulse" />
            ))}
          </div>
        ) : trips.length === 0 ? (
          <div className="bg-[#1A1A1A] border border-dashed border-[#333333] rounded-2xl p-8 text-center">
            <MapPin className="mx-auto text-[#666666]" />
            <p className="mt-2 text-[#A1A1AA]">No trips yet.</p>
          </div>
        ) : (
          <ul className="space-y-3">
            {trips.map((t) => (
              <li key={t.id}>
                <button
                  data-testid={`trip-item-${t.id}`}
                  onClick={() => navigate(`/trips/${t.id}/report`)}
                  className="w-full text-left bg-[#1A1A1A] border border-[#333333] rounded-2xl p-5 shadow-[0_4px_20px_rgba(12,27,51,0.06)] flex items-center justify-between"
                >
                  <div>
                    <h3 className="font-head text-lg font-bold text-[#F8FAFC]">
                      {t.destination_city}, {t.destination_country}
                    </h3>
                    <p className="text-sm text-[#A1A1AA]">
                      {t.start_date} → {t.end_date}
                    </p>
                    <div className="mt-2 flex items-center gap-2">
                      {t.has_report ? (
                        <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#EF9F27]">
                          <FileText size={15} /> Report ready
                        </span>
                      ) : (
                        <span className="text-sm font-semibold text-amber-600">Report not generated</span>
                      )}
                      {t.report_is_demo && <DemoBadge />}
                    </div>
                  </div>
                  <ChevronRight className="text-[#666666] shrink-0" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </AppShell>
  );
}
